import { Action, DidYouKnow, PlanetItems } from "../type";
import { useEffect, useState } from "react";
import data from "../../assets/actions.json";
import { ClimateGauge } from "../atoms/ClimateGauge";
import { RulesModal } from "../atoms/RulesModal";
import { CardSelector } from "../organisms/CardSelector";
import { Spinner } from "../atoms/Spinner";
import { Planet } from "../templates/Planet";
import { ModalEndGame } from "../organisms/ModalEndGame";
import "../../assets/animation.css";
import Konami from "../atoms/Konami";

export const Home = () => {
  const [cards, setCards] = useState<(Action | DidYouKnow)[]>();
  const [index, setIndex] = useState<number>(50);
  const [rulesModalVisible, setRulesModalVisible] = useState<boolean>(false);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [changeCard, setChangeCard] = useState<boolean>(false);
  const [newCard, setNewCard] = useState<boolean>(false);
  const [addEolienneTrigger, setAddEolienneTrigger] = useState<number>(0);
  const [addUsineTrigger, setAddUsineTrigger] = useState<number>(0);
  const [addCarTrigger, setAddCarTrigger] = useState<number>(0);
  const [addFarmTrigger, setAddFarmTrigger] = useState<number>(0);
  const [addHydroTrigger, setAddHydroTrigger] = useState<number>(0);
  const [addAtmosphereColorTrigger, setAddAtmosphereColorTrigger] =
    useState<number>(0);

  useEffect(() => {
    const shuffledActions = data.sort(() => Math.random() - 0.5);
    setCards(shuffledActions as Action[]);
    setRulesModalVisible(true);
  }, []);

  const handleTakeAction = () => {
    if (cards) {
      const indexModifier = (cards[currentCardIndex] as Action).takeAction
        .index;
      changeIndex(indexModifier);
    }
  };

  const addItemsOnPlanet = (item: PlanetItems) => {
    if (item === "eolienne") {
      setAddEolienneTrigger((prevTrigger) => prevTrigger + 1);
    } else if (item === "usine") {
      setAddUsineTrigger((prevTrigger) => prevTrigger + 1);
    } else if (item === "car") {
      setAddCarTrigger((prevTrigger) => prevTrigger + 1);
    } else if (item === "farm") {
      setAddFarmTrigger((prevTrigger) => prevTrigger + 1);
    } else if (item === "hydro") {
      setAddHydroTrigger((prevTrigger) => prevTrigger + 1);
    }
  };

  const removeItemsOnPlanet = (item: PlanetItems) => {
    if (item === "eolienne") {
      if (addEolienneTrigger > 0)
        setAddEolienneTrigger((prevTrigger) => prevTrigger - 1);
    } else if (item === "usine") {
      if (addUsineTrigger > 0)
        setAddUsineTrigger((prevTrigger) => prevTrigger - 1);
    } else if (item === "car") {
      if (addCarTrigger > 0) setAddCarTrigger((prevTrigger) => prevTrigger - 1);
    } else if (item === "farm") {
      if (addFarmTrigger > 0)
        setAddFarmTrigger((prevTrigger) => prevTrigger - 1);
    } else if (item === "hydro") {
      if (addHydroTrigger > 0)
        setAddHydroTrigger((prevTrigger) => prevTrigger - 1);
    }
  };

  const handleDontTakeAction = () => {
    if (cards) {
      const indexModifier = (cards[currentCardIndex] as Action).dontTakeAction
        .index;
      changeIndex(indexModifier);
    }
  };

  const changeIndex = (indexModifier: number) => {
    if (index + indexModifier >= 100) {
      setIndex(100);
      setCards([]);
    } else if (index + indexModifier <= 0) {
      setIndex(0);
      setCards([]);
    }
    if (index + indexModifier < 100 && index + indexModifier > 0) {
      if (
        cards &&
        cards[currentCardIndex] &&
        (cards[currentCardIndex] as Action).takeAction &&
        (cards[currentCardIndex] as Action).takeAction.addOnPlanet
      ) {
        addItemsOnPlanet(
          (cards[currentCardIndex] as Action).takeAction.addOnPlanet!,
        );
      }

      if (
        cards &&
        cards[currentCardIndex] &&
        (cards[currentCardIndex] as Action).dontTakeAction &&
        (cards[currentCardIndex] as Action).dontTakeAction.removeOnPlanet
      ) {
        removeItemsOnPlanet(
          (cards[currentCardIndex] as Action).dontTakeAction.removeOnPlanet!,
        );
      }

      setAddAtmosphereColorTrigger(
        (prevTrigger) => prevTrigger + indexModifier,
      );

      setIndex((prevIndex) => prevIndex + indexModifier);
    }
  };

  const onCardFinished = () => {
    if (cards && cards.length > 0) {
      setChangeCard(true);
      setTimeout(() => {
        setNewCard(true);
      }, 800);
      setTimeout(() => {
        const updatedCards = [...cards];
        updatedCards.splice(currentCardIndex, 1);
        setCurrentCardIndex(
          (prevIndex) => (prevIndex + 1) % updatedCards.length,
        );
        setCards(updatedCards);
        setChangeCard(false);
      }, 1000);
      setNewCard(false);
    }
  };

  function onRulesModalClose() {
    setRulesModalVisible(false);
  }

  return (
    <>
      <Konami />
      <RulesModal onClose={onRulesModalClose} visible={rulesModalVisible} />

      <div className="flex h-screen">
        <div className="w-1/2">
          <div className=" py-3 bg-white rounded-full bg-gradient-to-b from-white to-true-gray">
            <ClimateGauge indice={index} />
          </div>
          <Planet
            addEolienneTrigger={addEolienneTrigger}
            addUsineTrigger={addUsineTrigger}
            addCarTrigger={addCarTrigger}
            addFarmTrigger={addFarmTrigger}
            addHydroTrigger={addHydroTrigger}
            addAtmosphereColorTrigger={addAtmosphereColorTrigger}
          />
        </div>
        <div className={"w-1/2 h-full flex items-center justify-center"}>
          {cards ? (
            cards.length > 0 ? (
              <div
                className={`w-full h-full flex items-center justify-center ${
                  changeCard ? "slide-and-tilt" : ""
                } ${newCard ? "flip-vertical-right-all" : ""}`}
              >
                <CardSelector
                  card={cards[currentCardIndex]}
                  handleDontTakeAction={handleDontTakeAction}
                  handleTakeAction={handleTakeAction}
                  onCardFinished={onCardFinished}
                />
              </div>
            ) : (
              <ModalEndGame index={index} />
            )
          ) : (
            <Spinner />
          )}
        </div>
      </div>
    </>
  );
};
